import { format } from 'date-fns'

export function formatEventTime(
  utcTime,
  formatString = 'EEE do MMM yy h:mmbbb',
  showTimezone = true
) {
  if (!utcTime) return ''

  const date = new Date(utcTime)
  const formattedDate = format(date, formatString)

  if (!showTimezone) {
    return formattedDate
  }

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timezoneAbbr = getTimezoneAbbreviation(userTimezone, date)

  return `${formattedDate} ${timezoneAbbr}`
}

function getTimezoneAbbreviation(timezone, date) {
  try {
    const formatter = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      timeZoneName: 'short',
    })

    const parts = formatter.formatToParts(date)
    const timezonePart = parts.find((part) => part.type === 'timeZoneName')

    return timezonePart ? timezonePart.value : timezone
  } catch (error) {
    return timezone
  }
}

export function formatEventTimeRange(startTime, endTime, showTimezone = true) {
  if (!startTime) return ''

  const startDate = new Date(startTime)
  const endDate = new Date(endTime)

  const isSameDay = startDate.toDateString() === endDate.toDateString()

  if (isSameDay) {
    const startFormatted = format(startDate, 'EEE do MMM yy h:mmbbb')
    const endFormatted = format(endDate, 'h:mmbbb')

    if (showTimezone) {
      const timezoneAbbr = getTimezoneAbbreviation(
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        startDate
      )
      return `${startFormatted} - ${endFormatted} ${timezoneAbbr}`
    }

    return `${startFormatted} - ${endFormatted}`
  }

  const startFormatted = formatEventTime(
    startTime,
    'EEE do MMM yy h:mmbbb',
    showTimezone
  )
  const endFormatted = formatEventTime(
    endTime,
    'EEE do MMM yy h:mmbbb',
    showTimezone
  )
  return `${startFormatted} - ${endFormatted}`
}

export function getTimezoneInfo(utcTime) {
  if (!utcTime) return null

  const date = new Date(utcTime)
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return {
    utc: date.toISOString(),
    local: date.toString(),
    userTimezone,
    offset: date.getTimezoneOffset(),
    formatted: formatEventTime(utcTime),
  }
}
